<template>
  <div class="distribution-levels-component">
    <div class="stepper-container">
      <template v-for="(step, index) in steps">
        <div class="stepper-step" :key="'step' + index">
          <div class="stepper-step-content">
            <div class="step-content">
              <div class="step-number">{{$t('marketplaceAdministration.step')}} {{ index + 1 }}</div>
              <div class="step-strategy">
                <span class="icon"><StrategyIcon/></span><span class="label">{{ strategyTextsComputed[index] }}</span>
              </div>
              <div class="step-time">
                <span class="icon"><StopwatchIcon/></span><span class="label">{{ step.time }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="stepper-divider"
             :key="'divider' + index"
             v-if="index < steps.length - 1"></div>
      </template>
      <span class="stepper-step">
        <div class="stepper-step-content icon">
          <PipelineCircleFilledIcon small/>
        </div>
      </span>
    </div>
  </div>
</template>

<script>

import StrategyIcon from "@/components/icons/StrategyIcon";
import StopwatchIcon from "@/components/icons/StopwatchIcon";
import PipelineCircleFilledIcon from "@/components/icons/PipelineCircleFilledIcon";
import {computed} from "@vue/composition-api";

export default {
  name: "DistributionLevelsComponent",
  components: {PipelineCircleFilledIcon, StopwatchIcon, StrategyIcon},
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    strategyOptions:{
      type: Array,
      default: () => []
    }
  },
  setup(props) {

    const strategyTextsComputed = computed(() => {
      let output = []
      props.steps.forEach((step, index)=>{
        props.strategyOptions.forEach(strategyOption => {
          if(strategyOption.value === step.strategy){
            output.push(strategyOption.text)
          }
        })
        if(output.length <= index) output.push('')
      })
      return output
    })

    return {strategyTextsComputed}
  }
}
</script>

<style scoped lang="scss">
.distribution-levels-component {
  .stepper-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    justify-content: space-between;
    padding-left: 18px;
    padding-right: 32px;
    padding-bottom: 16px;
    overflow-x: auto;
  }

  // Single step
  .stepper-step {
    position: relative;
    flex: 0 1 auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 4px;

    .stepper-step-content {
      position: relative;
      background-color: transparent;
      border-color: transparent;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75rem;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      width: 140px;
      height: 96px;

      // Last element (big dot)
      &.icon {
        margin-top: calc(50% - 16px);
        width: 66px;
        height: 66px;
      }
    }

    .step-content {
      background-color: $white;
      border: 2px solid  map-get($grey, 'lighten-blue-1');
      border-radius: 5px;
      padding: 8px 10px;
      width: 100%;
      height: 100%;

      .step-number {
        border-bottom: 0.5px solid map-get($grey, 'lighten-blue-1');
        color: map-get($grey, 'lighten-blue-1');
        font-size: 18px;
        font-weight: 500;
        line-height: 18px;
        padding-bottom: 6px;
        margin-bottom: 4px;
      }

      .step-strategy {
        padding-top: 2px;
        padding-bottom: 2px;

        .icon {
          display: inline-block;
          width: 28px;

          svg {
            width: auto;
            height: 16px;
          }
        }

        .label {
          color: map-get($grey, 'lighten-blue-1');
          font-size: 16px;
          line-height: 20px;
        }
      }

      .step-time {
        padding-top: 2px;
        padding-bottom: 2px;

        .icon {
          display: inline-block;
          width: 28px;

          svg {
            width: auto;
            height: 19px;
          }
        }

        .label {
          color: map-get($grey, 'lighten-blue-1');
          font-size: 16px;
          line-height: 20px;
        }
      }
    }

    // Stepper divider for continuous line
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      content: '';
      background-color: map-get($grey, 'lighten-blue-1');
      height: 1px;
    }

    // First step: Remove left line
    &:first-child {
      &::before {
        left: 50%;
      }
    }

    // Last step: Remove right line
    &:last-child {
      &::before {
        right: 50%;
      }
    }
  }

  .stepper-divider {
    background-color: map-get($grey, 'lighten-blue-1');
    box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    align-self: flex-start;
    flex: 1 1 auto;
    margin-top: 58px;
    transition: inherit;
    max-width: 100%;
    min-width: 0;
    height: 3px;

  }
}
</style>

<!-- the icon is not in scope -->
<style lang="scss">
.distribution-levels-component {
  .stepper-step .stepper-step-content.icon {
    .pipelinecirclefilledicon {
      .a {
        fill: map-get($grey, 'lighten-blue-1');
      }
    }
  }
}
</style>
